var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHorizontal = function SvgHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.013 5.616a.5.5 0 0 1 .704.064l1.667 2a.5.5 0 0 1 0 .64l-1.667 2a.5.5 0 0 1-.768-.64l.983-1.18H4.068l.983 1.18a.5.5 0 1 1-.768.64l-1.667-2a.5.5 0 0 1 0-.64l1.667-2a.5.5 0 1 1 .768.64L4.068 7.5h7.865l-.984-1.18a.5.5 0 0 1 .064-.704",
    clipRule: "evenodd"
  })));
};
export { SvgHorizontal as ReactComponent };
export default __webpack_public_path__ + "93e590217e5ad77163ab1980ca8d1c39.svg";